import type { SalarySystemType } from '../enums/SalarySystemType'

export class SystemSalaryMiniEntity {
  createdAt?: string
  updatedAt?: string
  id?: number
  name?: string | null
  type?: SalarySystemType
  numberOfDrivers?: number
}
